import { Box } from "@mui/material";
import { Dayjs } from "dayjs";
import { RefObject } from "react";
import { useLiveCursorTime } from "../hooks/useLiveCursorTime";

interface LiveCursorLineProps {
  videoStart: Dayjs;
  visibleStart: Dayjs;
  visibleDuration: number;
  trackRef?: RefObject<HTMLElement | null>;
}

// A timeline playhead isolated into its own leaf so the live clock drives only
// this vertical line via rAF, leaving the surrounding tracks on the coarse clock.
export const LiveCursorLine = ({
  videoStart,
  visibleStart,
  visibleDuration,
  trackRef,
}: LiveCursorLineProps) => {
  const offset = visibleStart.diff(videoStart, "second", true);
  const liveTime = useLiveCursorTime({
    trackRef,
    visibleDuration,
    visibleStartSeconds: offset,
  });

  const currentTimePercent = ((liveTime - offset) / visibleDuration) * 100;

  return (
    <Box
      sx={{
        position: "absolute",
        left: `${currentTimePercent}%`,
        top: 0,
        bottom: 0,
        width: "2px",
        bgcolor: "primary.main",
        opacity: 0.8,
        pointerEvents: "none",
        zIndex: 10,
      }}
    />
  );
};
